import AMPIFrameResizer from './AMPIFrameResizerContainer';

export default AMPIFrameResizer;
